export enum DropMessageType {
  Success = 0,
  Error = 1,
  Warning = 2,
  Info = 3,
  None = 4,
}

export const VALIDATION_MESSAGES = {
  // ==================== Validation Messages ====================
  FAILED_TO_LOAD_DATA: 'Failed to load data.',
  FAILED_TO_ADD_TIMESHEET: 'Failed to add timesheet.',
  FAILED_TO_SAVE_DATA: 'Failed to save data.',
  FAILED_TO_UPDATE_DATA: 'Failed to update data.',
  FAILED_TO_DELETE_DATA: 'Failed to delete data.',
  FAILED_TO_APPROVE_DATA: 'Failed to approve data.',
  FAILED_TO_DISAPPROVE_DATA: 'Failed to disapprove data.',
  FAILED_TO_REJECT_DATA: 'Failed to reject data.',
  // ==================== Success Messages ====================
  DELETED_SUCCESSFULLY: 'Deleted successfully.',
  SAVED_SUCCESSFULLY: 'Saved successfully.',
  UPDATED_SUCCESSFULLY: 'Updated successfully.',
  APPROVED_SUCCESSFULLY: 'Approved successfully.',
  REJECTED_SUCCESSFULLY: 'Rejected successfully.',
};

export function getValidationMessage(msg: any, fallback: string): string {
  return msg && String(msg).trim().length > 0 ? msg : fallback;
}

const VALIDATION_MESSAGE_MAP: Record<string, string> = {
  Add: VALIDATION_MESSAGES.FAILED_TO_ADD_TIMESHEET,
  Save: VALIDATION_MESSAGES.FAILED_TO_SAVE_DATA,
  Update: VALIDATION_MESSAGES.FAILED_TO_UPDATE_DATA,
  Delete: VALIDATION_MESSAGES.FAILED_TO_DELETE_DATA,
  Approve: VALIDATION_MESSAGES.FAILED_TO_APPROVE_DATA,
  Disapprove: VALIDATION_MESSAGES.FAILED_TO_DISAPPROVE_DATA,
  Reject: VALIDATION_MESSAGES.FAILED_TO_REJECT_DATA,
  Load: VALIDATION_MESSAGES.FAILED_TO_LOAD_DATA,
};

export function checkMessageTypeAndMessage(
  response: any,
  action?: string
): { messageType: DropMessageType; message: string } {
  const messageType: DropMessageType = response?.messageType ?? DropMessageType.None;

  const fallbackMessage =
    VALIDATION_MESSAGE_MAP[action ?? 'Load'] ?? VALIDATION_MESSAGES.FAILED_TO_LOAD_DATA;

  const message = getValidationMessage(response?.message, fallbackMessage);

  return { messageType, message };
}
